"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = tslib_1.__importDefault(require("../core"));
var FeatureFlagClient = /** @class */ (function () {
    function FeatureFlagClient(apiKey, analyticsWebClient, featureFlagUser, options) {
        this.client = new core_1.default(apiKey, analyticsWebClient, featureFlagUser, options);
    }
    FeatureFlagClient.prototype.ready = function () {
        return this.client.ready();
    };
    FeatureFlagClient.prototype.getFlagValue = function (flagKey, defaultValue, options) {
        return this.client.getFlagValue(flagKey, defaultValue, options);
    };
    FeatureFlagClient.prototype.getFlagDetails = function (flagKey, defaultValue, options) {
        return this.client.getFlagDetails(flagKey, defaultValue, options);
    };
    FeatureFlagClient.prototype.getFlags = function () {
        return this.client.getFlags();
    };
    FeatureFlagClient.prototype.on = function (flagKey, defaultValue, callback, options) {
        return this.client.on(flagKey, defaultValue, callback, options);
    };
    FeatureFlagClient.prototype.onAnyFlagUpdated = function (callback) {
        return this.client.onAnyFlagUpdated(callback);
    };
    FeatureFlagClient.prototype.updateFeatureFlagUser = function (featureFlagUser) {
        return this.client.updateFeatureFlagUser(featureFlagUser);
    };
    FeatureFlagClient.prototype.destroy = function () {
        this.client.destroy();
    };
    return FeatureFlagClient;
}());
exports.default = FeatureFlagClient;
